import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import usePaymentFlowMachine from '../../../hooks/machines/usePaymentFlowMachine';
import AutopayConfirmation from '../../molecules/PaymentModalStates/autopay/AutopayConfirmation';
import AutopayError from '../../molecules/PaymentModalStates/autopay/AutopayError';
import AutopayForm from '../../molecules/PaymentModalStates/autopay/AutopayForm';
import CancelAutopayConfirmation from '../../molecules/PaymentModalStates/autopay/CancelAutopayConfirmation';
import ManageAutopay from '../../molecules/PaymentModalStates/autopay/ManageAutopay';
const Autopay = ({ resetTabFocus }) => {
    const [, autopayActor] = usePaymentFlowMachine();
    const { successType } = autopayActor.context;
    useEffect(() => {
        resetTabFocus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autopayActor.value]);
    if (autopayActor.matches('manage')) {
        return _jsx(ManageAutopay, {});
    }
    if (autopayActor.matches('edit')) {
        return _jsx(AutopayForm, {});
    }
    if (autopayActor.matches('success')) {
        if (successType === 'unenrolling') {
            return _jsx(CancelAutopayConfirmation, {});
        }
        if (successType === 'enrolling') {
            return _jsx(AutopayConfirmation, {});
        }
        if (successType === 'updating') {
            return _jsx(AutopayConfirmation, { hasBeenEdited: true });
        }
    }
    if (autopayActor.matches('error')) {
        return _jsx(AutopayError, {});
    }
    return null;
};
export default Autopay;
